import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import { useSkeleton } from '../../contexts/SkeletonContext.js';
import styles from './SkeletonListSymbol.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
/**
 * @see https://oss.fin.navercorp.com/pages/finance-fe/deFign/v7?path=/story/ui_defign-ui-skeleton-skeletonlistsymbol--skeleton-list-symbol
 */
function SkeletonListSymbol() {
  var _useSkeleton = useSkeleton(),
    isPage = _useSkeleton.isPage;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', {
      'type-page': isPage
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('skeleton', 'symbol')
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('skeleton', 'text')
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('skeleton', 'text-short')
  }));
}

export { SkeletonListSymbol as default };
